import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

export interface ClickEvent {
  area: string;
  value: any;
}

@Injectable({
  providedIn: 'root'
})
export class TransferClickService {

  private readonly clickSubject = new Subject<ClickEvent>();

  /**
   * Observable that emits when a click event occurs.
   */
  public readonly click$: Observable<ClickEvent> = this.clickSubject.asObservable();

  /**
   * Emits a click event with the specified area and value.
   * @param area The area where the click originated or is targeted.
   * @param value The value associated with the click.
   */
  public emitClick(area: string, value: any): void {
    this.clickSubject.next({ area, value });
  }
}
